export default "__VITE_ASSET__Cg5Pmtz3__"